import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.sass';
import NumberField from 'components/common/NumberField';
import Label from 'components/common/Label';
import ButtonIcon from 'components/common/ButtonIcon';
import EditIcon from '@material-ui/icons/Edit';
import ButtonAttachFile, {AttachFileList} from 'components/common/AttachFile';
import FormEditText from 'components/common/FormEditText';
import {connect} from 'react-redux';
import {modalShow, modalHide} from 'actions/modal';


function toAttachmentList(attachmentList, files) {
  if (!files) return null;

  const dictAttachmentList = {};
  if (attachmentList) {
    for (let i = 0; i < attachmentList.length; i++) {
      const attachment = attachmentList[i];
      dictAttachmentList[attachment.fileStorageId] = attachment;
    }
  }

  return files.map(a => ({fileName: a.name, fileStorageId: a.id, id: dictAttachmentList[a.id] && dictAttachmentList[a.id].id}));
}

function fromAttachmentList(attachmentList) {
  if (!attachmentList) return null;
  return attachmentList.map(a => ({name: a.fileName, id: a.fileStorageId}));
}

@connect()
class Penalty extends PureComponent {
  state = {
    isChange: false,

    id: null,
    percent: "",
    sum: "",
    attachmentList: [],
    comment: "",
    fetchingFiles: [],
  };

  componentWillMount() {
    this.propsToState(this.props);
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.propsToState(nextProps);
  }

  propsToState = (props) => {
    const {collectionCaseSum} = props;
    const {isChange} = this.state;

    if (isChange) return;
    if (!props.value) return;
    const propsValue = {
      id: props.value.id,
      sum: props.value.sum,
      attachmentList: props.value.attachmentList,
      comment: props.value.comment
    };

    const stateValue = {
      id: this.state.id,
      sum: this.state.sum,
      attachmentList: this.state.attachmentList,
      comment: this.state.comment
    };

    let nextState = {};

    if (JSON.stringify(propsValue.attachmentList) !== JSON.stringify(stateValue.attachmentList)) {
      nextState.attachmentList = propsValue.attachmentList;
    }

    if (propsValue.id !== stateValue.id) {
      nextState.id = propsValue.id;
    }

    if (propsValue.sum !== stateValue.sum) {
      if (collectionCaseSum) {
        nextState.percent = 100 / (collectionCaseSum / propsValue.sum);
        if (nextState.percent) nextState.percent = parseFloat(nextState.percent).toFixed(2);
      }

      nextState.sum = propsValue.sum;
    }

    if (propsValue.comment !== stateValue.comment) {
      nextState.comment = propsValue.comment;
    }

    this.setState(nextState)
  };

  handlerOnChange = (nextState) => {
    const {onChange} = this.props;

    this.setState({...nextState, isChange: true});
    if (onChange) {
      const state = {...this.state, ...nextState};

      onChange({id: state.id, sum: state.sum, attachmentList: state.attachmentList, comment: state.comment});
      this.setState({isChange: false});
    }
  };

  handlerPercentOnChange = (percent) => {
    const {collectionCaseSum} = this.props;
    if (percent || percent === 0) {
      const nextState = {percent, sum: collectionCaseSum && (percent && parseFloat(collectionCaseSum / 100 * percent).toFixed(2)) || null};
      this.handlerOnChange(nextState);
    } else {
      this.handlerOnChange({percent: null, sum: null});
    }
  };

  handlerSumOnChange = (sum) => {
    const {collectionCaseSum} = this.props;
    if (sum || sum === 0) {
      const nextState = {percent: (collectionCaseSum && parseFloat(100 / (collectionCaseSum / sum)).toFixed(2)) || null, sum};
      this.handlerOnChange(nextState);
    } else {
      this.handlerOnChange({percent: null, sum: null});
    }
  };

  handlerAttachFileButtonOnFetching = (fetchingFile) => {
    const {fetchingFiles} = this.state;
    this.setState({fetchingFiles: (fetchingFiles || []).concat(fetchingFile)});
  };

  handlerAttachFileButtonOnFetchingComplete = (fetchingFile) => {
    const {fetchingFiles} = this.state;
    this.setState({fetchingFiles: (fetchingFiles || []).filter(a => a.key !== fetchingFile.key)});
  };

  handlerAttachFileButtonOnChange = (fileObject) => {
    const {attachmentList} = this.state;
    this.handlerOnChange({attachmentList: (attachmentList || []).concat({fileName: fileObject.name, fileStorageId: fileObject.id})})
  };

  handlerEditOnClick = () => {
    const {dispatch} = this.props;
    const {comment} = this.state;

    dispatch(modalShow(
      <FormEditText
        title={'Редактирование комментария'}
        defaultText={comment}
        onOk={v => {this.handlerOnChange({comment: v}); dispatch(modalHide());}}
        onCancel={() => dispatch(modalHide())}
      />
    ));

  };

  render() {
    const {className: classBox} = this.props;
    const {sum, attachmentList, comment, percent, fetchingFiles} = this.state;

    return (
      <div className={cx(styles.box, classBox)}>
        <div className={styles.penalty}>
          <Label className={styles.label}>Штраф</Label>
          <NumberField value={percent} onChange={this.handlerPercentOnChange} className={styles.penaltyPercent}/>
          <Label>%</Label>
          <NumberField value={sum} onChange={this.handlerSumOnChange} className={styles.penaltySum}/>
          <Label>руб</Label>
          <ButtonIcon style={{marginLeft: '12px'}} onClick={this.handlerEditOnClick} tooltip={"Редактировать комментарий"}><EditIcon className={styles.icon} /></ButtonIcon>
          <ButtonAttachFile
            classIcon={styles.icon}
            onFetching={this.handlerAttachFileButtonOnFetching}
            onFetchingComplete={this.handlerAttachFileButtonOnFetchingComplete}
            onFetchingError={this.handlerAttachFileButtonOnFetchingComplete}
            onChange={this.handlerAttachFileButtonOnChange}
          />
        </div>
        <Label className={styles.comment}>{comment}</Label>
        <AttachFileList
          fetchingFiles={fetchingFiles}
          className={styles.attachFiles}
          files={fromAttachmentList(attachmentList)}
          onChange={v => this.handlerOnChange({attachmentList: toAttachmentList(attachmentList, v)})}
        />
      </div>
    );
  }
}

Penalty.propTypes = {
  className: PropTypes.string,
  collectionCaseSum: PropTypes.number,
  value: PropTypes.objectOf({
    id: PropTypes.string,
    sum: PropTypes.number,
    attachmentList: PropTypes.arrayOf({
      id: PropTypes.string,
      fileStorageId: PropTypes.string,
      name: PropTypes.string,
    }),
    comment: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export default Penalty;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/Penalty/Penalty.jsx